import React, { useState } from 'react';
import { Grid, Button, TextField } from '@mui/material';
import { EventType } from '../../../../types';
import { eventsService } from '../../../../core/services/eventsService';
import styles from '../SchedulerSetting.module.scss';

interface EditEventTypeProps {
	type: EventType;
	handleBackClick?: () => void;
	onEventTypeUpdated?: () => void;
}

const EditEventType: React.FC<EditEventTypeProps> = ({
	type,
	handleBackClick,
	onEventTypeUpdated,
}) => {
	const [typeBuffer, setTypeBuffer] = useState({
		label: type.label || type.name || '',
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);

		if (!typeBuffer.label.trim()) {
			setError('Event type is required');
			return;
		}

		try {
			setIsSubmitting(true);
			await eventsService.updateEventType({
				...type,
				label: typeBuffer.label,
				active: true, // Always pass true
			});

			onEventTypeUpdated?.();
			setTimeout(() => {
				handleBackClick?.();
			}, 500);
		} catch (err: any) {
			setError(err?.message || 'Failed to update event type');
			setIsSubmitting(false);
		}
	};

	return (
		<div className={styles.editTimeOffReason}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Button className={styles.backButton} onClick={handleBackClick}>
						Back
					</Button>
					<Button
						className={styles.submitButton}
						onClick={handleSubmit}
						disabled={isSubmitting || !typeBuffer.label.trim()}
					>
						{isSubmitting ? 'Saving...' : 'Save'}
					</Button>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Edit Event Type</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={handleSubmit}>
				<TextField
					label="Event Type"
					name="label"
					value={typeBuffer.label}
					onChange={(e) => {
						setTypeBuffer({ ...typeBuffer, label: e.target.value });
						if (error) {
							setError(null);
						}
					}}
					placeholder="Enter event type"
					className={styles.input}
					margin="normal"
					fullWidth
					inputProps={{ maxLength: 200 }}
					error={!!error}
					helperText={error || ''}
				/>
			</form>
		</div>
	);
};

export default EditEventType;

